import UserPreference, {
  getDefaults as getUserPreferenceDefaults,
  UserPreferenceOptions,
  UserPreferenceType,
} from 'models/UserPreference';
import { InboundReferralsFilterState } from 'stores/inboundReferralsStore';

// The Inbound Referrals inbox's Filters selection, saved per (user, acting client) so it survives a
// logout. Stored exactly as the store holds it — reporting names and group ids, no
// {id, name} options — so it goes back into the store as-is.
export type InboundReferralsFilterValue = InboundReferralsFilterState;

export interface InboundReferralsFilterOptions extends UserPreferenceOptions {
  type: UserPreferenceType.INBOUND_REFERRALS_FILTER;
  value: InboundReferralsFilterValue;
}

export function getDefaults(): InboundReferralsFilterOptions {
  return {
    ...getUserPreferenceDefaults(),
    type: UserPreferenceType.INBOUND_REFERRALS_FILTER,
    value: {},
  };
}

export default class InboundReferralsFilter extends UserPreference {
  declare value: InboundReferralsFilterValue;

  constructor(options: Partial<InboundReferralsFilterOptions> = {}) {
    const opts = { ...getDefaults(), ...options };

    super(opts);

    this.value = opts.value;
  }
}
